<template>
  <div>
    <template v-if="person">
      <div class="panel wraper panel-gray">
        <div class="panel-header">
          <transition :name="transName || 'slide-l'" mode="out-in">
            <div class="panel-title" :key="$route.params.id">
              <unit-path :id="id"></unit-path>
            </div>
          </transition>
        </div>
        <transition :name="transName || 'slide-l'" mode="out-in">
          <div class="panel-body" :key="$route.params.id">
            <p v-if="person.lastEdited" class="in-top">
              <small class="view-label">
                <q-icon name="fas fa-user-edit"/> {{editor}} {{person.lastEdited | formatTime}}
              </small>
            </p>
            <p v-if="person.name">
              <small class="view-label">ФИО</small>
              <span class="text-bolder">{{person.name}}</span>
            </p>
            <p v-if="person.appointment">
              <small class="view-label">Должность</small>
              <span class="text-bolder">{{person.appointment}}</span>
            </p>
            <p v-if="formatTel">
              <small class="view-label">Контакты</small>
              <span class="text-bolder" v-html="formatTel"></span>
            </p>
            <p v-if="person.comment">
              <small class="view-label">Заметки</small>
              <span class="text-bolder">{{person.comment}}</span>
            </p>
            <media-bar :medias="mediasCopy" @selectMedia="showAttach"></media-bar>
          </div>
        </transition>
      </div>
      <pop-btn v-if="notReader" class="mobile-hide" :btns="btns"/>
      <pop-hold v-if="notReader" class="mobile-only" :btns="btns"/>
      <media-modal :done="createAttach" ref="mediaModal"/>
    </template>
    <template v-else>
      <div class="row justify-center">
        <q-spinner-dots :size=100 color="primary"></q-spinner-dots>
      </div>
    </template>
    <mediator
        :editEnabled="notReader"
        ref="mediator"
        @mediaEdited="mediaEdited"
        @mediaDeleted="mediaDeleted"
        @doNext="doNext"
    />
  </div>
</template>


<script>
import UnitPath from './unit-path.vue';
import viewCommon from './view-common.js';
import PopBtn from 'components/pop-btn.vue';
import PopHold from 'components/pop-hold.vue';
import MediaModal from './media-modal.vue';
import Mediator from './mediator.vue';
import MediaBar from './media-bar.vue';

export default {
  name: 'personview',
  props: ['transName'],
  components: {
    UnitPath,
    PopBtn,
    PopHold,
    MediaModal,
    Mediator,
    MediaBar,
  },
  extends: viewCommon,
  data() {
    return {};
  },
  mounted() {
    this.$watch('person', (a) => {
      document.title = a.label;
    }, {
      immediate: true,
    });
    this.$watch('$route.query.mid', (val) => {
      console.log('HANDLER //////////////////////', val, '//', this.mediasCopy.length);
      if (val && this.mediasCopy[0]) {
        const ind = this.mediasCopy.findIndex(item => item.id === val);
        if (ind > -1) {
          this.showAttach(this.mediasCopy[ind]);
          this.$router.replace({ query: {} }); // remove query
        }
      }
    }, {
      immediate: true,
    });
  },
  computed: {
    mediasCopy() {
      return this.person.medias ?
        this.person.medias.map(media => Object.assign({}, media))
        :
        [];
    },
    btns() {
      return [
        {
          color: 'warning',
          click: this.goEdit,
          icon: 'create',
          tooltip: 'Изменить',
        },
        {
          color: 'positive',
          icon: 'fa-paperclip',
          tooltip: 'Добавить вложение',
          prefix: '+',
          click: this.chooseMedia,
        },
        {
          color: 'positive',
          click: this.doCut,
          icon: 'file_upload',
          tooltip: 'Выбрать для перемещения',
          hide: !this.isAdmin,
        },
        {
          color: 'negative',
          click: this.doDelete,
          icon: 'delete_forever',
          tooltip: 'Удалить',
          hide: !this.isAdmin,
        },
      ];
    },
    editor() {
      return this.$store.getters.userScreenName(this.person.editedBy);
    },
    formatTel() {
      return this.$utils.telStringLinks(this.person.telephones);
    },
    person() {
      return this.$store.getters.formatUnit(this.id);
    },
    pid() {
      return this.person.parent_id;
    },
  },
  methods: {
    doDelete() {
      this.$q.dialog({
        title: 'Подтвердите удаление',
        'prevent-close': true,
        message: `${this.person.label} будет безвозвратно удален!`,
        ok: {
          flat: true,
          color: 'negative',
          label: 'Удалить',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Отмена',
        },
      })
        .then(() => this.$store.dispatch('deleteUnit', this.person))
        .then(() => {
          if (this.$route.name === 'found') {
            this.$router.push('/found');
          } else {
            this.$router.push(`/list/${this.pid}`);
          }
        })
        .catch((err) => {
          if (err) console.log(err);
        });
    },
    doCut() {
      this.$store.dispatch('placeToBuffer', { id: this.id, parent_id: this.pid });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/person-view.vue